import { connect } from 'react-redux';
import RelatedProductList from '../components/RelatedProduct/RelatedProductList';
import { getRelatedProducts } from '../selectors/tagWizardSelector';

const mapStateToProps = function(store) {
    const productVariationRelatedProductList = Object.values(
        store.productVariation.relatedProductList
    );

    return {
        sliderSectionID: '#related-products-section',
        list:
            productVariationRelatedProductList.length > 0
                ? productVariationRelatedProductList
                : getRelatedProducts(store.tagWizard.present),
        currencyFormat: store.cart.currencyFormat,
        currencyDisplayCode: store.cart.currencyDisplayCode,
        locale: store.cart.locale,
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {};
};
const ConnectedRelatedProductList = connect(
    mapStateToProps,
    mapDispatchToProps
)(RelatedProductList);

export default ConnectedRelatedProductList;
